/**
 * Created by pandemio on 9/20/18.
 */
import React from 'react';
import { Col, Card,  CardBody, CardHeader, Container, Row } from 'reactstrap';
import { Spring } from 'react-spring'
import { TimingAnimation, Easing } from 'react-spring/dist/addons'

/** Multiple Language imports **/
import { withLocalize } from "react-localize-redux";
import { renderToStaticMarkup } from 'react-dom/server'; // Fix by the author. Do not remove even if it's not resolved
import { Translate } from "react-localize-redux";
import global from "../translations/global.json"
/** End of Multiple Language imports **/

import SelectorProduct from "./selectors/selector-product";
import SelectorLesson from "./selectors/selector-lesson";
import ApiCalls from "../custom-classes/api-calls";
import LanguageManager from '../custom-classes/language-manager';
import NavbarMobile from './navbar/navbar-mobile';

// This is the item list
class Syllabus extends React.Component{

    constructor(props){
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);
        // To support language library add the following lines
        this.props.initialize({
            languages: [
                { name: "English", code: "en" },
                { name: "Español", code: "es" }
            ],
            options: { renderToStaticMarkup, defaultLanguage: LanguageManager.getLanguage("en") }
        });
        this.props.addTranslation(global);

        this.state = {
            syllabusInfo: null,
            productId: null // The product ID (course)
        };
    }

    /**
     * Handle the lessons call
     */
    callLessons = () => (newValue) => {
        this.setState({'productId': newValue, syllabusInfo: null});
    };

    /**
     * Call the syllabus data
     */
    callSyllabus = () => (newValue) => {

        let apiSyllabus = ApiCalls.getSyllabus(this.state.productId.value, newValue.value);
        let dataSyllabus;
        apiSyllabus.then(function(data){
            dataSyllabus = data.LessonModifierRequestModel.LessonDetailModel.Description;
        }).then(()=>{
            // Then, set the state
            this.setState({
                syllabusInfo: dataSyllabus
            });
        });
    };

    // Call the item list
    render() {
        return(
            <div>
                <NavbarMobile/>
                <Spring from={{opacity: 0}} to={{opacity: 1}} impl={TimingAnimation} config={{duration:450, easing: Easing.linear}}>
                    {
                        styles =>
                            <Container>
                                <Col sm={{size: 12, offset: 0}} lg={{size:12, offset: 0}} style={styles}>
                                    <Card className="card-white">
                                       <CardHeader className="card-cyan">
                                           <h4 className="white-text">
                                            <Translate id="syllabus.lesson-syllabus" options={{renderInnerHtml: true}}/>
                                           </h4>
                                           <small>
                                               <Translate id="syllabus.instructions" options={{renderInnerHtml: true}}/>
                                           </small>
                                       </CardHeader>
                                        <CardBody>
                                            <Row>
                                                <Col sm={{size:12}} md={{size:4}} lg={{size:3}}>
                                                    <p><b><Translate id="syllabus.select-class" options={{renderInnerHtml: true}}/></b></p>
                                                    <SelectorProduct updateParent={this.callLessons()}/>
                                                </Col>
                                                <Col sm={{size:12}} md={{size:8}} lg={{size:9}}>
                                                    <p><b><Translate id="syllabus.select-lesson" options={{renderInnerHtml: true}}/></b></p>
                                                    { this.state.productId !== null ?
                                                        <SelectorLesson data={this.state} updateParent={this.callSyllabus()} /> : null }
                                                </Col>
                                            </Row>
                                            <Row>
                                                { this.state.syllabusInfo != null ?
                                                    <div dangerouslySetInnerHTML={{ __html: (this.state.syllabusInfo)}}/> : null }
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Container>
                    }
                </Spring>
            </div>
        )
    };
}

export default withLocalize(Syllabus);


// WEBPACK FOOTER //
// ./src/components/syllabus.js